import { cn } from '@/utils/cn'

export function TeacherCode({
  code,
  className,
}: {
  code?: string | null
  className?: string
}) {
  const value = code?.trim() ?? ''
  const empty = !value
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded px-1.5 py-0.5 font-mono text-xs font-semibold tracking-wide',
        empty ? 'bg-gray-100 text-gray-300' : 'bg-gray-200 text-gray-700',
        className,
      )}
    >
      {empty ? '—' : value}
    </span>
  )
}
